import React from 'react';

import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import Container from '@mui/material/Container';

import { PropsFromRedux } from '../containers/AgentLeaderboardPageContainer';

import AgentLeaderboardContainer from '../containers/AgentLeaderboardContainer';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: '100%',
    },
    spacing: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
    }
  }),
);

const AgentLeaderboardPage = (props: PropsFromRedux) => {
    const classes = useStyles();

    return (
      <Container maxWidth="lg" className={[classes.container, classes.spacing].join(" ")}>
        <AgentLeaderboardContainer
          initialDelay={0}
        />
      </Container>
    )
};

export default AgentLeaderboardPage;